import { ErrorHandler } from "@/Helpers/ErrorHandler.js"
import {
  convertObjectKeysToCamelCase,
  convertObjectKeysToSnakeCase,
} from "@/Helpers/Utils.js"
import DeviceRepository from "@/repositories/DeviceRepository.js"

export class DeviceService {
  constructor() {
    this.list = []
    this.device = {}
    this.repository = DeviceRepository
  }

  async update(Id, device) {
    try {
      const params = convertObjectKeysToSnakeCase(device)
      const { data, status, error } = await this.repository.update(Id, params)
      if (status !== 200) return new ErrorHandler(error, "http", status)
      this.device = convertObjectKeysToCamelCase(data.data)

      return this.device
    } catch (e) {
      const errorMessage = e.response.data.message
      return new ErrorHandler(errorMessage, "http")
    }
  }

  async getDevices(params = {}) {
    try {
      const { data, status, error } = await this.repository.list(params)
      if (status !== 200) return new ErrorHandler(error, "http", status)
      this.list = data.data.map((device) =>
        convertObjectKeysToCamelCase(device),
      )

      return this.list
    } catch (e) {
      const errorMessage = e.response.data.message
      return new ErrorHandler(errorMessage, "http")
    }
  }

  async getAvailableDevicesForAppliance(applianceId, serial = null) {
    const params = {
      unassigned: 1,
      appliance_id: applianceId,
      per_page: 50,
    }
    if (serial) params.serial = serial
    return this.getDevices(params)
  }

  async getManufacturerInfo(deviceId) {
    try {
      const response = await this.repository.deviceInfo(deviceId)
      if (response && response.data && response.data.data) {
        return convertObjectKeysToCamelCase(response.data.data)
      }
      return null
    } catch (e) {
      const errorMessage = e.response.data.message
      return new ErrorHandler(errorMessage, "http")
    }
  }

  async getCapabilities(deviceId) {
    try {
      const { data, status, error } =
        await this.repository.capabilities(deviceId)
      if (status !== 200) return new ErrorHandler(error, "http", status)

      return convertObjectKeysToCamelCase(data.data)
    } catch (e) {
      const errorMessage = e.response.data.message
      return new ErrorHandler(errorMessage, "http")
    }
  }

  async generateToken(deviceId, amount, unit) {
    return this.postTokenRequest(deviceId, { type: "credit", amount, unit })
  }

  async generateControlToken(deviceId, type) {
    return this.postTokenRequest(deviceId, { type })
  }

  async postTokenRequest(deviceId, params) {
    try {
      const { data, status, error } = await this.repository.generateToken(
        deviceId,
        params,
      )
      if (status !== 200 && status !== 201)
        return new ErrorHandler(error, "http", status)

      return convertObjectKeysToCamelCase(data.data)
    } catch (e) {
      const errorMessage = e.response.data.message
      return new ErrorHandler(errorMessage, "http")
    }
  }
}
